(function () {
  'use strict';

  class HeroBannerCarousel {
    constructor(section) {
      this.section  = section;
      this.slides   = Array.from(section.querySelectorAll('[data-slide]'));
      this.current  = 0;
      this.interval = null;
      const attr    = section.getAttribute('data-carousel-speed');
      this.speed    = attr ? parseInt(attr, 10) * 1000 : 5000;
      if (this.slides.length > 1) this._init();
    }

    _init() {
      this._play();
      this.section.addEventListener('mouseenter', () => this._pause());
      this.section.addEventListener('mouseleave', () => this._play());
      this.section.addEventListener('focusin',    () => this._pause());
      this.section.addEventListener('focusout',   () => this._play());
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this._pause();
    }

    _goTo(index) {
      this.slides[this.current].classList.remove('is-active');
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides[this.current].classList.add('is-active');
    }

    _next()  { this._goTo(this.current + 1); }
    _play()  { clearInterval(this.interval); this.interval = setInterval(() => this._next(), this.speed); }
    _pause() { clearInterval(this.interval); }
  }

  function applyHorizontalAlign(section) {
    const align   = section.getAttribute('data-h-align');
    const content = section.querySelector('.hero-banner__content');
    if (!align || !content) return;
    const map = {
      left:   ['flex-start', 'left'],
      center: ['center',     'center'],
      right:  ['flex-end',   'right']
    };
    if (map[align]) {
      content.style.alignItems = map[align][0];
      content.style.textAlign  = map[align][1];
    }
  }

  function initAll() {
    document.querySelectorAll('[data-carousel]').forEach(carousel => {
      const section = carousel.closest('.hero-banner');
      if (section) new HeroBannerCarousel(section);
    });
    document.querySelectorAll('.hero-banner').forEach(applyHorizontalAlign);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // Soporte para el editor de Shopify (Theme Editor live reload)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => {
      const s = e.target.querySelector('.hero-banner');
      if (!s) return;
      const c = s.querySelector('[data-carousel]');
      if (c) new HeroBannerCarousel(s);
      applyHorizontalAlign(s);
    });
    document.addEventListener('shopify:section:reorder', initAll);
  }
})();